import { Layout as RaLayout, useAuthenticated } from 'react-admin'
import { Menu } from './Menu'

const Layout = (props) => {
  useAuthenticated()
  return <RaLayout {...props} menu={Menu} />
}

export { Layout }